import { reset } from 'redux-form';
import {
  CONTACT_HOST_START,
  CONTACT_HOST_SUCCESS,
  CONTACT_HOST_ERROR,
} from '../../constants';
import showToaster from '../../helpers/toasterMessages/showToaster';
import { createThreadItems as mutation, createInquiryReservation } from '../../lib/graphql';
import { contactHostClose } from './contactHostModal';

export const contactHost = (
  listId,
  host,
  content,
  startDate,
  endDate,
  personCapacity,
  hostEmail,
  firstName,
  startTime,
  endTime,
  isAverage,
  isDayTotal,
  discount,
  serviceFee,
  total,
  isSpecialPriceAssigned,
  discountType,
  priceForDays,
  hostServiceFee,
  securityDeposit,
  dayDifference,
  currency,
  basePrice
) => {

  return async (dispatch, getState, { client }) => {

    try {

      dispatch({
        type: CONTACT_HOST_START,
      });

      let account = getState().account.data;

      const { data } = await client.mutate({
        mutation,
        variables: {
          listId,
          host,
          content,
          type: 'inquiry',
          startDate,
          endDate,
          personCapacity,
          startTime: parseFloat(startTime),
          endTime: parseFloat(endTime)
        }
      });

      if (data?.CreateThreadItems?.status == 400) {
        return showToaster({ messageId: 'contactHostError', toasterType: 'error' });
      }

      await client.mutate({
        mutation: createInquiryReservation,
        variables: {
          threadId: data.CreateThreadItems.threadId,
          threadItemId: data.CreateThreadItems.id,
          hostId: host,
          checkIn: startDate,
          checkOut: endDate,
          guests: personCapacity,
          basePrice: priceForDays,
          currency,
          guestServiceFee: serviceFee,
          hostServiceFee,
          total,
          averagePrice: isAverage,
          startTime: parseFloat(startTime),
          endTime: parseFloat(endTime),
          discount,
          discountType: "percentage",
          securityDeposit,
          dayDifference,
          isSpecialPriceAssigned
        }
      });


      if (data?.CreateThreadItems?.status == 400) {
        dispatch({
          type: CONTACT_HOST_ERROR,
        });
        showToaster({ messageId: 'contactHostError', toasterType: 'error' });
      } else if (data?.CreateThreadItems) {
        dispatch({
          type: CONTACT_HOST_SUCCESS,
        });
        showToaster({ messageId: 'contactHost', toasterType: 'success' })
      }

      dispatch(contactHostClose());
      dispatch(reset('ContactHostForm'));

    } catch (error) {

      dispatch({
        type: CONTACT_HOST_ERROR,
        payload: {
          error
        }
      });
      return false;
    }

    return true;
  };
}